<template>
    <div class="content">
      <div class="data_head">
        <p>预/报推送</p>
        <div class="nav_switch">
          <span>推送开关</span>
          <el-switch
            @change="changeSwitch"
            v-model="value"
            active-text="开"
            inactive-text="关"
            active-color="#13ce66"
            inactive-color="#333333"
          >
          </el-switch>
        </div>
<!--邮箱-->
        <div class="emailContent">
          <span class="emailTitle">邮箱:</span>
          <el-tag
            :key="index"
            v-for="(item,index) in emailArr"
            closable
            :disable-transitions="false"
            @click="clickTag(item,index)"
            @close="handleClose(item)">
            {{item}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" type="primary"  @click="showInput">+新增邮箱</el-button>
          <el-button  class="button-new-tag" size="small" type="success"  @click="submitList">保存</el-button>
        </div>


      </div>
      <!--推送条件-->
<!--      <div class="tableContent">-->
<!--        <p>推送条件</p>-->
<!--        <div>-->
<!--          <el-form ref="form" :inline="true" :model="form" label-width="180px">-->
<!--            <div v-for="(item, index) in form.sendOperation" :key="index">-->
<!--              <el-form-item-->
<!--                :label="'警报参数'+[index+1]"-->
<!--                :prop="'sendOperation.' + index + '.measureNo'"-->
<!--                :rules="{ required: true, message: '警报参数不能为空', trigger: 'blur'}">-->
<!--                <el-input size="mini" v-model="item.measureNo"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item-->
<!--                label="突变值"-->
<!--                :prop="'sendOperation.' + index + '.breakValue'"-->
<!--                :rules="[{required: true, message: '突变值不能为空', trigger: 'blur'}]">-->
<!--                <el-input size="mini" v-model="item.breakValue"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item-->
<!--                label="最大值"-->
<!--                :prop="'sendOperation.' + index + '.maxValue'"-->
<!--                :rules="[{required: true, message: '最大值不能为空', trigger: 'blur'}]">-->
<!--                <el-input size="mini" v-model="item.maxValue"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-button v-if="index+1 == form.sendOperation.length" @click="addItem" type="primary">增加条件</el-button>-->
<!--                <el-button v-if="index !== 0" @click="deleteItem(item, index)" type="danger">删除条件</el-button>-->
<!--              </el-form-item>-->
<!--            </div>-->
<!--          </el-form>-->
<!--          <div style="text-align: center">-->
<!--            <el-button   @click="submitList" type="primary" v-loading="submitLoad">提交</el-button>-->
<!--          </div>-->
<!--        </div>-->
<!--&lt;!&ndash;        <div id="channel_chart" style="width: 500px;height: 400px"></div>&ndash;&gt;-->

<!--      </div>-->
<!--echarts图-->
    </div>
</template>

<script>
  // import  {createChartLine} from "../../util/drawCharts"
  // import echarts from 'echarts'
    export default {
        name: "MailboxPush",
        data(){
            return{
                value: true,
                // emailArr: ['1234564989@qq.com', '33338883@qq.com', '0000000@qq.com'],
                emailArr: [],
                inputVisible: false,
                inputValue: '',
                sendForm:{
                    title:'',
                    unUsualNum:'',
                    maxValue:''
                },
                submitLoad:false,
                form: {
                  status:'',
                  emails:'',
                  sendOperation: [
                   {
                     measureNo: "",
                     breakValue: "",
                     maxValue: ''
                   }
                 ]
             },
        }
        },
        created(){
            this.getEmailList()
        },
        mounted(){
            // createChartLine(1,1)
            // this.drawEcharts()
        },
        methods:{
            drawEcharts(){
                var option = {
                    tooltip: {
                        trigger:'axis',
                        formatter: '{b0}({a0}): {c0}<br />{b1}({a1}): {c1}%'
                    },
                    legend: {
                        data:['销量','占比']
                    },
                    xAxis: {
                        data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
                    },
                    yAxis: [ {
                        type: 'value',
                        name: '销量',
                        show:true,
                        splitLine:{show:false},
                        axisLine: {
                            lineStyle: {
                                color: '#5e859e',
                                width: 2
                            }
                        }
                    },
                        {
                            type: 'value',
                            name: '占比',
                            min: 0,
                            max: 100,
                            interval: 10,
                            splitLine:{show:false},
                            axisLabel: {
                                formatter: '{value} %'
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#5e859e',//纵坐标轴和字体颜色
                                    width: 2
                                }
                            }
                        }],
                    series: [{
                        name: '销量',
                        type: 'bar',
                        barWidth : '50%',
                        data: [15, 30, 46, 20, 20, 30]
                    },{
                        name: '占比',
                        type: 'line',
                        smooth:true,
                        // yAxisIndex:[0,1],
                        data: [5, 1, 2, 4, 9, 66]
                    }]
                };
                // createChartLine(option,'channel_chart')
                let myChart = echarts.init(document.getElementById('channel_chart'))
                myChart.setOption(option)
            },
            getEmailList(){
                this.$axios.get('/api/monitor/emailSend/getEmails').then((res) => {
                    if(res.data.status === 200){
                        if( Object.keys(res.data.datas.values).length!==0){
                            if(res.data.datas.values.emails==''){this.emailArr = []}
                            else{this.emailArr = res.data.datas.values.emails.split(',')}
                            this.value = res.data.datas.values.status
                            this.form.sendOperation = res.data.datas.values.emailJsons
                        } else {
                            this.emailArr = []
                            this.value = true
                            this.form.sendOperation = this.form.sendOperation
                        }
                    }
                    return
                })
            },
            /*开关改变*/
            changeSwitch(){
                console.log(this.value, 1111)
            },
            saveEmail(){
                console.log(this.emailArr,'邮箱集合名称')
            },
            clickTag(item,index){
                // console.log(item,index,111)
                this.inputVisible=true
                this.inputValue=item
                this.emailArr.splice(this.emailArr.indexOf(item), 1);
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleClose(item) {
                this.emailArr.splice(this.emailArr.indexOf(item), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputValue = this.inputValue
                if (inputValue) {
                    this.emailArr.push(inputValue)
                }
                this.inputVisible = false;
                this.inputValue = ''
            },
            /*动态增加行*/
            addItem() {
                this.form.sendOperation.push({
                    measureNo: "",
                    breakValue: "",
                    maxValue: ''
                });
            },
            sure(form) {
                console.log(this.form.sendOperation.length, "length");
                this.$refs[form].validate(valid => {
                    if (valid) {
                        alert("submit!");
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            deleteItem(item, index) {
                this.form.sendOperation.splice(index, 1);
            },
            submitList(){
                this.submitLoad = true
                this.form.status=this.value,
                this.form.emails=this.emailArr.toString()
                this.$axios.post('/api/monitor/emailSend/addEmails',this.form).then((res) => {
                    if(res.data.status === 200){
                        this.$message({
                            message: '提交成功',
                            type:'success'
                        });
                        this.getEmailList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type:'warning'
                        });
                    }
                    return
                })
                this.submitLoad = false
            },
        }
    }
</script>

<style scoped>
  .content{
    padding: 10px 10px;
    border: 1px solid rgb(19,100,182);
    height: calc(100% - 20px);
    margin:0 15px;
    background-image: linear-gradient(to bottom right,rgba(6,21,43,1), rgba(13,39,82,0.8));
    color: #FFFFFF;
  }
  .data_head{
   background-color:rgb( 21,49,97);
   padding: 20px 20px;
  }
  .data_head p{
    padding: 0;
    margin: 0;
    font-size: 18px;
  }
  .nav_switch{
    margin: 10px 0;
    font-size: 18px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .nav_switch span{
    margin-right: 20px;
  }
  /deep/ .el-switch__label {
    color: #ffffff;
  }
  .emailContent{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .emailTitle{
    font-size: 18px;
    color: #ffffff;
    margin-right: 20px;
  }
  /deep/ .el-tag{
    font-size: 16px;
    margin: 5px 5px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 200px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  /*main*/
  .tableContent{
    background-color:rgb( 21,49,97);
    padding: 20px 20px;
    margin-top: 20px;
  }

  .tableContent p{
    padding: 0;
    margin: 0;
    font-size: 18px;
  }
  /deep/ .el-form-item__label{
    color: #ffffff;
    font-size: 18px;
  }



</style>



// WEBPACK FOOTER //
// src/components/systemSetting/MailboxPush.vue